var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavePdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.48 4.21H20.72V7H19.01V0H23.77V1.3H20.73V2.91H23.49V4.21H23.48ZM13.21 1.3V5.7H13.81C14.3 5.7 14.68 5.53 14.94 5.18C15.2 4.84 15.34 4.32 15.34 3.64V3.34C15.34 2.66 15.21 2.15 14.94 1.81C14.68 1.47 14.29 1.3 13.79 1.3H13.21ZM11.5 7V0H13.79C14.42 0 14.98 0.14 15.48 0.42C15.98 0.7 16.37 1.1 16.65 1.61C16.93 2.12 17.07 2.69 17.08 3.33V3.65C17.08 4.29 16.94 4.87 16.67 5.37C16.39 5.88 16.01 6.28 15.51 6.56C15.01 6.85 14.45 6.99 13.84 7H11.5ZM5.71 3.32H6.83C7.16 3.32 7.42 3.24 7.59 3.07C7.76 2.91 7.85 2.68 7.85 2.38C7.85 2.05 7.76 1.79 7.58 1.6C7.4 1.4 7.16 1.31 6.85 1.3H5.71V3.32ZM5.71 4.62V7H4V0H6.84C7.38 0 7.86 0.0999999 8.28 0.3C8.7 0.5 9.02 0.78 9.25 1.14C9.48 1.5 9.59 1.92 9.59 2.38C9.59 3.06 9.34 3.61 8.85 4.02C8.35 4.43 7.67 4.63 6.81 4.63H5.72L5.71 4.62ZM14 10C14.55 10 15 10.45 15 11V19.78L18.72 16.07C19.11 15.68 19.74 15.68 20.13 16.07C20.52 16.46 20.52 17.09 20.13 17.48L15.47 22.14C14.69 22.92 13.42 22.92 12.64 22.14L7.98 17.48C7.59 17.09 7.59 16.46 7.98 16.07C8.37 15.68 9 15.68 9.39 16.07L12.99 19.67V11C12.99 10.45 13.44 10 13.99 10H14ZM27 21C27.55 21 28 21.45 28 22V27C28 28.1 27.1 29 26 29H2C0.9 29 0 28.1 0 27V22C0 21.45 0.45 21 1 21C1.55 21 2 21.45 2 22V27H26V22C26 21.45 26.45 21 27 21Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavePdf);
export default ForwardRef;